
import { getWeeklyStats } from '@/api';
import DatePicker from '@/components/searchPage/DatePicker.vue';
import StateSelect from '@/components/dashBoard/selectsFields/components/StateSelect/StateSelect.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import { addDays } from 'date-fns';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Header, User } from '@/models/main';
import { ReportWeeklyStats } from '@/models/reports';
import { notificationErrorText, timeZoneDefault } from '@/utils/PortalConstants';
import { format, utcToZonedTime } from 'date-fns-tz';

@Component({
  components: {
    BackButton,
    DatePicker,
    StateSelect,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class StatsReport extends Vue {
  private isLoading = false;
  private dates: string[] = [];
  private states: string[] = [];
  private statsReport: ReportWeeklyStats = {};
  private user: User;

  private headers: Header[] = [
    { text: 'Date', value: 'date', align: 'left' },
    { text: 'Total', value: 'total', align: 'left', sortable: false },
    { text: 'Uncompleted', value: 'uncompleted', align: 'left' },
    { text: 'Completed', value: 'completed', align: 'left' },
    { text: 'Percentage', value: 'percentage', align: 'left' },
  ];

  private changeDate(dates: string[]): void {
    this.dates = dates;
  }
  private changeStates(states: string[]) {
    this.states = states;
  }
  // Weekly report
  private getWeeklyStatReport() {
    this.isLoading = true;
    const params = {
      states: this.states,
      dates: this.dates,
    };
    getWeeklyStats(params)
      .then(res => {
        this.statsReport = res;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error getting Weekly report',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private mounted(): void {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    const fromDate = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd'); // today
    const toDate = format(utcToZonedTime(addDays(new Date(), -7), userTimeZone), 'yyyy-MM-dd'); // +5 days
    this.dates = [fromDate, toDate];
  }
}
